import React, { Component } from 'react'
import { connect } from 'react-redux'

function mapStateToProps(state) {
    return {
        firstName: state.getIn(['authorization', 'user', 'firstName'], ''),
        lastName: state.getIn(['authorization', 'user', 'lastName'], ''),
        email: state.getIn(['authorization', 'user', 'email'], ''),
    }
}

export default function (InnerComponent) {
    @connect(mapStateToProps)
    class hocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return hocConnect
}
